var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{style:({ 'width': _vm.maxWidth + 'px' }),attrs:{"controls":""}},[_c('source',{attrs:{"src":(_vm.api + "/paste/" + (this.code) + "/raw")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }